export default "__VITE_ASSET__D0RHNZE1__"